export default __webpack_public_path__ + "static/media/caleb-04-icon.6a14d963.svg";